<template>
  <!-- 核心信息 -->
  <a-form-model ref="ruleForm" :model="form.lesseeInfoBo" :rules="rules">
    <h3 class="label">核心信息</h3>
    <a-row>
      <a-col :span="4" class="mr30">
        <a-form-model-item :colon="false" label="客户姓名" prop="lesseeName">
          <a-input v-model="form.lesseeInfoBo.lesseeName" :maxLength="16" placeholder="客户姓名" />
        </a-form-model-item>
      </a-col>

      <a-col :span="4" class="mr30">
        <a-form-model-item :colon="false" label="客户电话" prop="lesseePhone">
          <a-input v-model="form.lesseeInfoBo.lesseePhone" :maxLength="11" placeholder="客户电话" @blur="searchBtn(form.lesseeInfoBo.lesseePhone)" />
        </a-form-model-item>
      </a-col>

      <a-col :span="4" class="mr30">
        <a-form-model-item :colon="false" label="微信">
          <a-input v-model="form.lesseeInfoBo.lesseeWechat" :maxLength="11" placeholder="微信" />
        </a-form-model-item>
      </a-col>

      <a-col :span="4" class="mr30">
        <a-form-model-item :colon="false" label="性别" prop="lesseeSex">
          <a-select v-model="form.lesseeInfoBo.lesseeSex" placeholder="请选择">
            <a-select-option v-for="item in sexOptions" :key="item.dictValue" :value="item.dictValue">
              {{ item.dictLabel }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>

      <a-col :span="4" class="mr30">
        <a-form-model-item :colon="false" label=" ">
          <a-button @click="addPhone">+添加备用电话</a-button>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    sexOptions: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    form: {
      handler () {},
      deep: true,
      immediate: true
    }
  },
  data () {
    return {}
  },
  methods: {
    searchBtn (val) {
      this.$emit('searchBtn', val)
    },
    addPhone () {
      this.$emit('addPhone')
    }
  }
}
</script>

<style lang="less" scoped>
.mr30 {
  margin-right: 30px;
}

.label {
  font-size: 18px;
  margin: 20px 0;
}
</style>
